import { Dialog } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useState } from "react";
import { toggleCart } from "store/slices/main.slice";
import CartView from "./Cart";
import Details from "./Details";
import OrderType from "./OrderType";
import PaymentView from "./Payment";
import CheckoutView from "./Checkout";

type Props = {
  setShowPopup: (v: boolean) => void;
  setOrderTotal: (v: number) => void;
};

const CartDialog = (props: Props) => {
  const dispatch = useAppDispatch();
  const { settings } = useAppSelector(({ main }) => main);

  const [stage, setStage] = useState(
    settings.ApplyTakeOutDeliveryPrice !== 0 ? "CART" : "ORDERTYPE"
  );

  const showCart = useAppSelector(({ main }) => main.showCart);
  useEffect(() => {
    setStage(settings.ApplyTakeOutDeliveryPrice !== 0 ? "CART" : "ORDERTYPE");
  }, [settings]);

  return (
    <Dialog
      onClose={() => {
        dispatch(toggleCart());
      }}
      open={showCart}
      maxWidth="lg"
    >
      <div className="min-w-[80vw] md:min-w-[600px] min-h-[70vh] py-2.5 flex flex-col">
        {stage === "ORDERTYPE" && <OrderType setStage={setStage} />}
        {stage === "CART" && <CartView setStage={setStage} />}
        {stage === "DETAILS" && <Details setStage={setStage} />}
        {stage === "CHECKOUT" && (
          <CheckoutView
            setStage={setStage}
            setShowPopup={props.setShowPopup}
            setOrderTotal={props.setOrderTotal}
          />
        )}
        {stage === "PAYMENT" && <PaymentView setStage={setStage} />}
      </div>
    </Dialog>
  );
};

export default CartDialog;
